// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Wpxdm","content":"style_content__6TR2S","icon":"style_icon__g3zRO","custom-button-style":"style_custom-button-style__Cp8KU"};